import React from "react";
import { Button, Modal } from "antd";

import { Download } from "lucide-react";
const ViewUseCase = ({ singleData, openModal, onClose }) => {
  return (
    <Modal
      title={
        <div
          style={{
            background: "#006666",
            color: "#fff",
            padding: "12px",
            borderRadius: "4px",
          }}
        >
          View Use Case Details
        </div>
      }
      centered
      open={openModal}
      onOk={() => onClose()}
      onCancel={() => onClose()}
      footer={[
        <Button
          key="ok"
          type="primary"
          style={{ background: "#006666", color: "white" }}
          onClick={onClose}
        >
          OK
        </Button>,
      ]}
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <input
                    class={`form-control `}
                    type="text"
                    placeholder="Enter Name.."
                    value={singleData?.name}
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Email</label>
                  <input
                    class={`form-control `}
                    type="text"
                    placeholder="Enter Email.."
                    value={singleData?.email}
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Phone No</label>
                  <input
                    class={`form-control `}
                    type="text"
                    placeholder="Enter Phone No.."
                    value={singleData?.phoneNo}
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="mb-3">
                  <label class="form-label">Process Name</label>
                  <input
                    class={`form-control `}
                    type="text"
                    placeholder="Enter Process Name.."
                    value={singleData?.processName}
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-12">
                <div class="mb-3">
                  <label class="form-label">Process Description</label>
                  <div
                    class={`form-control `}
                    style={{ backgroundColor: "#eaecef" }}
                    dangerouslySetInnerHTML={{
                      __html: singleData?.description,
                    }}
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-12">
                <div class="mb-3">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      window.open(`${singleData?.filePath}`, "_blaank");
                    }}
                    class="border border-1 p-2 space-common d-flex justify-content-start gap-3 align-items-center"
                  >
                    <h6>Download Attachment</h6>
                    <Download size={16} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewUseCase;
